/* Progressive enhancement only: the menu, navigation and ordering work without JS. */
(() => {
  const init = () => {
    const header = document.querySelector('.dg-header');
    if (header && !header.dataset.observed) {
      header.dataset.observed = 'true';
      const update = () => document.documentElement.style.setProperty('--dg-header-height', `${header.offsetHeight}px`);
      update();
      if ('ResizeObserver' in window) new ResizeObserver(update).observe(header);
    }
    document.querySelectorAll('.dg-mobile-menu').forEach(menu => {
      if (menu.dataset.ready) return;
      menu.dataset.ready = 'true';
      menu.addEventListener('click', event => { if (event.target.closest('a')) menu.open = false; });
      menu.addEventListener('keydown', event => {
        if (event.key === 'Escape') { menu.open = false; menu.querySelector('summary').focus(); }
      });
    });
  };
  init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('click', event => {
    document.querySelectorAll('.dg-mobile-menu[open]').forEach(menu => { if (!menu.contains(event.target)) menu.open = false; });
  });
})();
